package com.mgacreative.hotelru.feature.admin.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.outlined.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mgacreative.hotelru.domain.model.Agency
import com.mgacreative.hotelru.shared.ui.designsystem.components.LanguageSelectorRow
import com.mgacreative.hotelru.shared.ui.designsystem.components.verticalScrollbar
import com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun AdminAgencyManagementScreen(onNavigateBack: () -> Unit, onNavigate: (String) -> Unit = {}) {
    val viewModel = koinViewModel<AdminAgencyViewModel>()
    val agencies by viewModel.agencies.collectAsState()
    val isLoading by viewModel.isLoading.collectAsState()

    var showAddAgency by remember { mutableStateOf(false) }
    var editingAgency by remember { mutableStateOf<Agency?>(null) }
    var agencyToDelete by remember { mutableStateOf<Agency?>(null) }

    val listState = rememberLazyListState()

    Scaffold(
        containerColor = Color(0xFFF8FAFC),
        topBar = {
            Surface(
                color = Color.White,
                shadowElevation = 1.dp
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 12.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        IconButton(onClick = onNavigateBack) {
                            Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = l10n("Geri"), tint = Color(0xFF0F172A))
                        }
                        Spacer(Modifier.width(8.dp))
                        Column {
                            Text(
                                text = l10n("Acenta Yönetimi"),
                                fontSize = 18.sp,
                                fontWeight = FontWeight.Bold,
                                color = Color(0xFF0F172A)
                            )
                            Text(
                                text = "${agencies.size} ${l10n("Kayıtlı Acenta")}",
                                fontSize = 12.sp,
                                color = Color(0xFF64748B)
                            )
                        }
                    }

                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        OutlinedButton(
                            onClick = { onNavigate("AgencyContractScreen") },
                            shape = RoundedCornerShape(10.dp),
                            border = BorderStroke(1.dp, Color(0xFFCBD5E1)),
                            contentPadding = PaddingValues(horizontal = 12.dp, vertical = 8.dp)
                        ) {
                            Icon(Icons.Outlined.HistoryEdu, contentDescription = null, tint = Color(0xFF475569), modifier = Modifier.size(16.dp))
                            Spacer(Modifier.width(6.dp))
                            Text(l10n("Sözleşmeler"), fontSize = 13.sp, fontWeight = FontWeight.SemiBold, color = Color(0xFF334155))
                        }

                        Button(
                            onClick = { showAddAgency = true },
                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF2563EB)),
                            shape = RoundedCornerShape(10.dp),
                            contentPadding = PaddingValues(horizontal = 14.dp, vertical = 8.dp)
                        ) {
                            Icon(Icons.Default.Add, contentDescription = null, tint = Color.White, modifier = Modifier.size(18.dp))
                            Spacer(Modifier.width(6.dp))
                            Text(l10n("Acenta Ekle"), fontSize = 13.sp, fontWeight = FontWeight.SemiBold, color = Color.White)
                        }
                    }
                }
            }
        }
    ) { padding ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .verticalScrollbar(listState)
        ) {
            LazyColumn(
                state = listState,
                modifier = Modifier.fillMaxSize(),
                contentPadding = PaddingValues(16.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                if (isLoading) {
                    item {
                        LinearProgressIndicator(modifier = Modifier.fillMaxWidth())
                    }
                }

                if (agencies.isEmpty() && !isLoading) {
                    item {
                        Box(
                            modifier = Modifier.fillMaxWidth().padding(48.dp),
                            contentAlignment = Alignment.Center
                        ) {
                            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                Icon(Icons.Outlined.TravelExplore, contentDescription = null, tint = Color(0xFF94A3B8), modifier = Modifier.size(48.dp))
                                Spacer(Modifier.height(12.dp))
                                Text(l10n("Henüz acenta kaydı bulunmuyor"), fontSize = 15.sp, fontWeight = FontWeight.Bold, color = Color(0xFF0F172A))
                            }
                        }
                    }
                } else {
                    items(agencies, key = { it.id ?: it.name }) { agency ->
                        Card(
                            shape = RoundedCornerShape(16.dp),
                            colors = CardDefaults.cardColors(containerColor = Color.White),
                            elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
                            border = BorderStroke(1.dp, Color(0xFFE2E8F0)),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(16.dp),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                Row(
                                    verticalAlignment = Alignment.CenterVertically,
                                    modifier = Modifier.weight(1f)
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .size(44.dp)
                                            .clip(CircleShape)
                                            .background(Color(0xFFEEF2FF)),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        Icon(
                                            imageVector = Icons.Outlined.TravelExplore,
                                            contentDescription = null,
                                            tint = Color(0xFF6366F1),
                                            modifier = Modifier.size(22.dp)
                                        )
                                    }

                                    Spacer(Modifier.width(14.dp))

                                    Column {
                                        Text(
                                            text = agency.name,
                                            fontSize = 15.sp,
                                            fontWeight = FontWeight.Bold,
                                            color = Color(0xFF0F172A)
                                        )
                                        Spacer(Modifier.height(3.dp))
                                        Row(
                                            verticalAlignment = Alignment.CenterVertically,
                                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                                        ) {
                                            Surface(
                                                color = Color(0xFFFEF3C7),
                                                shape = RoundedCornerShape(6.dp)
                                            ) {
                                                Text(
                                                    text = "%${agency.commissionRate ?: 0.0} ${l10n("Komisyon")}",
                                                    fontSize = 11.sp,
                                                    fontWeight = FontWeight.Bold,
                                                    color = Color(0xFFB45309),
                                                    modifier = Modifier.padding(horizontal = 8.dp, vertical = 2.dp)
                                                )
                                            }

                                            if (!agency.contactInfo.isNullOrBlank()) {
                                                Text(
                                                    text = agency.contactInfo ?: "",
                                                    fontSize = 12.sp,
                                                    color = Color(0xFF64748B)
                                                )
                                            }
                                        }
                                    }
                                }

                                Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                                    IconButton(onClick = { editingAgency = agency }) {
                                        Icon(
                                            Icons.Outlined.Edit,
                                            contentDescription = l10n("Düzenle"),
                                            tint = Color(0xFF2563EB),
                                            modifier = Modifier.size(20.dp)
                                        )
                                    }
                                    IconButton(onClick = { agencyToDelete = agency }) {
                                        Icon(
                                            Icons.Outlined.Delete,
                                            contentDescription = l10n("Sil"),
                                            tint = Color(0xFFDC2626),
                                            modifier = Modifier.size(20.dp)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                item {
                    Spacer(Modifier.height(32.dp))
                }
            }
        }

        if (showAddAgency || editingAgency != null) {
            AgencyDialog(
                initialAgency = editingAgency,
                onDismiss = {
                    showAddAgency = false
                    editingAgency = null
                },
                onSave = { name, contact, commissionRate ->
                    if (editingAgency != null) {
                        editingAgency?.id?.let {
                            viewModel.updateAgency(it, name, contact, commissionRate)
                        }
                    } else {
                        viewModel.addAgency(name, contact, commissionRate)
                    }
                    showAddAgency = false
                    editingAgency = null
                }
            )
        }

        if (agencyToDelete != null) {
            val agency = agencyToDelete!!
            AlertDialog(
                onDismissRequest = { agencyToDelete = null },
                containerColor = Color.White,
                shape = RoundedCornerShape(20.dp),
                title = { Text(l10n("Acentayı Sil"), fontWeight = FontWeight.Bold) },
                text = { Text("${agency.name} ${l10n("kalıcı olarak silinecek. Onaylıyor musunuz?")}") },
                confirmButton = {
                    Button(
                        onClick = {
                            agency.id?.let { viewModel.deleteAgency(it) }
                            agencyToDelete = null
                        },
                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFDC2626)),
                        shape = RoundedCornerShape(8.dp)
                    ) {
                        Text(l10n("Sil"), color = Color.White, fontWeight = FontWeight.Bold)
                    }
                },
                dismissButton = {
                    TextButton(onClick = { agencyToDelete = null }) {
                        Text(l10n("İptal"), color = Color(0xFF64748B))
                    }
                }
            )
        }
    }
}

@Composable
fun AgencyDialog(
    initialAgency: Agency? = null,
    onDismiss: () -> Unit,
    onSave: (String, String, Double?) -> Unit
) {
    var name by remember { mutableStateOf(initialAgency?.name ?: "") }
    var contact by remember { mutableStateOf(initialAgency?.contactInfo ?: "") }
    var commission by remember { mutableStateOf(initialAgency?.commissionRate?.toString() ?: "") }

    val isEdit = initialAgency != null

    AlertDialog(
        onDismissRequest = onDismiss,
        containerColor = Color.White,
        shape = RoundedCornerShape(20.dp),
        title = { Text(if (isEdit) l10n("Acenta Düzenle") else l10n("Yeni Acenta Ekle"), fontWeight = FontWeight.Bold, fontSize = 18.sp) },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                OutlinedTextField(
                    value = name,
                    onValueChange = { name = it },
                    label = { Text(l10n("Acenta Adı")) },
                    singleLine = true,
                    shape = RoundedCornerShape(10.dp),
                    modifier = Modifier.fillMaxWidth()
                )
                OutlinedTextField(
                    value = contact,
                    onValueChange = { contact = it },
                    label = { Text(l10n("İletişim / E-posta / Telefon")) },
                    singleLine = true,
                    shape = RoundedCornerShape(10.dp),
                    modifier = Modifier.fillMaxWidth()
                )
                OutlinedTextField(
                    value = commission,
                    onValueChange = { commission = it },
                    label = { Text("${l10n("Komisyon Oranı")} (%)") },
                    singleLine = true,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                    shape = RoundedCornerShape(10.dp),
                    modifier = Modifier.fillMaxWidth()
                )
            }
        },
        confirmButton = {
            Button(
                onClick = {
                    if (name.isNotBlank()) {
                        onSave(name.trim(), contact.trim(), commission.replace(",", ".").toDoubleOrNull())
                    }
                },
                colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF2563EB)),
                shape = RoundedCornerShape(8.dp)
            ) {
                Text(l10n("Kaydet"), fontWeight = FontWeight.Bold, color = Color.White)
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) { Text(l10n("İptal"), color = Color(0xFF64748B)) }
        }
    )
}
